import { useContext } from "react";
import { ProDataGridContext } from "./ProDataGridContext";

export const useProDataGrid = () => useContext(ProDataGridContext);
